import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslationPipeModule } from "@modules/core/pipes/translation-pipe/translation-pipe.module";
import { SummaryGridComponent } from "@modules/main/components/step-summary/summary-grid/component/summary-grid.component";

@NgModule({
	declarations: [SummaryGridComponent],
	imports: [CommonModule, TranslationPipeModule],
	exports: [SummaryGridComponent]
})
export class SummaryGridModule {}
